import { FailureCodeEnum as InvoiceDisputedFailureCode } from 'anchor-ts-infra/src/dto/invoice';
export var BillingTriggerType = /*#__PURE__*/ function(BillingTriggerType) {
    /** Billed once, automatically, on client's approval of service/agreement. */ BillingTriggerType["OnApproval"] = "approval";
    /** Automatic, scheduled, recurring billing. */ BillingTriggerType["Ongoing"] = "ongoing";
    /** Billed once, manually, by the vendor. */ BillingTriggerType["OneTimeManual"] = "oneTimeManual";
    /** Manual recurring billing. Vendor is allowed to manually bill the client once. */ BillingTriggerType["RepeatableManual"] = "repeatableManual";
    BillingTriggerType["OneTimeInStages"] = "oneTimeInStages";
    BillingTriggerType["OnDemand"] = "onDemand";
    return BillingTriggerType;
}({});
export var PlaidAccountType = /*#__PURE__*/ function(PlaidAccountType) {
    PlaidAccountType["Depository"] = "depository";
    PlaidAccountType["Credit"] = "credit";
    PlaidAccountType["Loan"] = "loan";
    PlaidAccountType["Investment"] = "investment";
    PlaidAccountType["Other"] = "other";
    return PlaidAccountType;
}({});
export var PlaidDepositoryAccountSubtype = /*#__PURE__*/ function(PlaidDepositoryAccountSubtype) {
    PlaidDepositoryAccountSubtype["Checking"] = "checking";
    PlaidDepositoryAccountSubtype["Savings"] = "savings";
    PlaidDepositoryAccountSubtype["HSA"] = "hsa";
    PlaidDepositoryAccountSubtype["CD"] = "cd";
    PlaidDepositoryAccountSubtype["MoneyMarket"] = "money market";
    PlaidDepositoryAccountSubtype["Paypal"] = "paypal";
    PlaidDepositoryAccountSubtype["Prepaid"] = "prepaid";
    PlaidDepositoryAccountSubtype["CashManagement"] = "cash management";
    PlaidDepositoryAccountSubtype["EBT"] = "ebt";
    return PlaidDepositoryAccountSubtype;
}({});
export var VobQboState = /*#__PURE__*/ function(VobQboState) {
    VobQboState["Started"] = "started";
    VobQboState["ConnectionTriggered"] = "connectionTriggered";
    VobQboState["Canceled"] = "canceled";
    VobQboState["Done"] = "done";
    return VobQboState;
}({});
export var StartBillingOnEnum = /*#__PURE__*/ function(StartBillingOnEnum) {
    StartBillingOnEnum["SkipBillingOnAcceptance"] = "skipBillingOnAcceptance";
    StartBillingOnEnum["Earliest"] = "earliest";
    StartBillingOnEnum["StartPaused"] = "startPaused";
    return StartBillingOnEnum;
}({});
export const INVOICE_DASHBOARD_CARD_IDS = [
    'collection-rate',
    'anchor-vs-external',
    'avg-days-to-pay',
    'outstanding',
    'aging-breakdown',
    'avg-invoice',
    'paid',
    'pending',
    'overdue',
    'issued',
    'processing',
    'refunded',
    'voided',
    'disputed',
    'missing-payment-method',
    'client-approval-required',
    'payment-stopped',
    'payment-failed',
    'payment-validation-required',
    'payment-method-unverified'
];
export const DEFAULT_INVOICE_DASHBOARD_CARDS = [
    'collection-rate',
    'anchor-vs-external',
    'avg-days-to-pay',
    'outstanding',
    'aging-breakdown'
];
export var InvoicePaymentMethodStatus = /*#__PURE__*/ function(InvoicePaymentMethodStatus) {
    InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
    InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
    InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
    return InvoicePaymentMethodStatus;
}({});
export var LineItemPendingApprovalReason = /*#__PURE__*/ function(LineItemPendingApprovalReason) {
    LineItemPendingApprovalReason["AdHocCharge"] = "ad-hoc-charge";
    LineItemPendingApprovalReason["ServiceAmendment"] = "service-amendment";
    LineItemPendingApprovalReason["VariableExceedsCap"] = "variable-exceeds-cap";
    LineItemPendingApprovalReason["VariableZeroCap"] = "variable-zero-cap";
    LineItemPendingApprovalReason["RangeExceedsMaxPrice"] = "range-exceeds-max-price";
    LineItemPendingApprovalReason["VariableCumulative"] = "variable-cumulative";
    LineItemPendingApprovalReason["NonVariableCumulative"] = "non-variable-cumulative";
    LineItemPendingApprovalReason["OverlappingPeriod"] = "overlapping-period";
    return LineItemPendingApprovalReason;
}({});
export { InvoiceDisputedFailureCode };
export var IntegrationStatus = /*#__PURE__*/ function(IntegrationStatus) {
    IntegrationStatus["Error"] = "error";
    IntegrationStatus["Linked"] = "linked";
    IntegrationStatus["Unlinked"] = "unlinked";
    return IntegrationStatus;
}({});
export var PracticeManagement = /*#__PURE__*/ function(PracticeManagement) {
    PracticeManagement["Keeper"] = "keeper";
    PracticeManagement["Karbon"] = "karbon";
    PracticeManagement["ClientHub"] = "client-hub";
    PracticeManagement["FinancialCents"] = "financial-cents";
    return PracticeManagement;
}({});
export var Accounting = /*#__PURE__*/ function(Accounting) {
    Accounting["QBO"] = "qbo";
    Accounting["Xero"] = "xero";
    return Accounting;
}({});
export var IntegrationResponseStatus = /*#__PURE__*/ function(IntegrationResponseStatus) {
    IntegrationResponseStatus["Success"] = "success";
    IntegrationResponseStatus["Error"] = "error";
    return IntegrationResponseStatus;
}({});
export const isPracticeManagementIntegrationItem = (value)=>value.id !== undefined;
export function getSelectedUser(users, role, service, getIntegration) {
    const asignToUser = (s)=>{
        var _getIntegration;
        const assignedUserId = (_getIntegration = getIntegration(s)) === null || _getIntegration === void 0 ? void 0 : _getIntegration.assignedUserId(role.id);
        return assignedUserId && users ? users.find((user)=>user.id === assignedUserId) || null : null;
    };
    if (service.bundle) {
        return service.bundle.services.map(asignToUser).find((user)=>user !== null) || null;
    }
    return asignToUser(service);
}
export const isAccountingQbo = (accounting)=>accounting === "qbo";
export const isAccountingXero = (accounting)=>accounting === "xero";
